import { CarrierTypeEnum } from 'domains/shippingDomain';
import { ListMarkupParam, MarkupSkus } from 'domains/markupDomain';
import { Paged } from 'domains/appDomain';
import {
  Markup,
  MarkupTypeEnum,
  PartialMarkup,
  RevshopOrgMarkupDTO,
  RevshopOrgMarkupParams,
} from 'domains/markupDomain';
import api from 'utils/api';
const markupService = {
  getElementMarkups: async (orgId?: number) => {
    const pagedResp = await api.post<Paged<Markup>>(
      `/api/markups/list?page=0&size=100`,
      { type: MarkupTypeEnum.ELEMENT },
      orgId === undefined ? undefined : { 'X-Tenant-ID': orgId }
    );
    return pagedResp.content;
  },
  getGlobalMarkup: async (
    type:
      | MarkupTypeEnum.GLOBAL
      | MarkupTypeEnum.OUTSOURCE_PRINTING
      | MarkupTypeEnum.OUTSOURCE_SHIPPING
  ) => {
    const pagedResp = await api.post<Paged<Markup>>(
      `/api/markups/list?page=0&size=100`,
      { active: true, type }
    );
    if (pagedResp.content.length > 0) {
      return pagedResp.content[0];
    } else {
      return undefined;
    }
  },
  getRevshopMarkup: async () => {
    const pagedResp = await api.post<Paged<Markup>>(
      `/api/markups/list?page=0&size=100`,
      { active: true, type: MarkupTypeEnum.REVSHOP }
    );
    if (pagedResp.content.length > 0) {
      return pagedResp.content[0];
    } else {
      return undefined;
    }
  },
  getMarkups: async (param: ListMarkupParam) => {
    const pageNumber = param.page.currentPage - 1;
    const pageSize = param.page.pageSize || 10;
    return await api.post<Paged<Markup>>(
      `/api/markups/list?page=${pageNumber}&size=${pageSize}`,
      param.query
    );
  },
  createMarkup: async (markup: PartialMarkup) => {
    return await api.post<Markup>(`/api/markups`, markup);
  },
  updateMarkup: async (markup: PartialMarkup) => {
    return await api.put<Markup>(`/api/markups/${markup.id}`, markup);
  },
  removeMarkup: async (markupId: number) => {
    return await api.delete<void>(`/api/markups/${markupId}`);
  },

  getSkuMarkupSkus: async (
    orgId: number,
    type: MarkupTypeEnum.ORG_SKU | MarkupTypeEnum.REVSHOP_SKU
  ) => {
    return await api.get<MarkupSkus>(
      `/api/markups/option/skus?orgId=${orgId}&type=${type}`
    );
  },

  getNoShippingMarkupCarriers: async (orgId: number) => {
    return await api.get<CarrierTypeEnum[]>(
      `/api/markups/option/carrierTypes?orgId=${orgId}`
    );
  },
  createRevshopOrgMarkup: async (markup: RevshopOrgMarkupParams) => {
    return api.post<RevshopOrgMarkupDTO>(
      `/api/markups/revshop-org-markup`,
      markup
    );
  },
  updateRevshopOrgMarkup: async (markup: RevshopOrgMarkupParams) => {
    return api.put<RevshopOrgMarkupDTO>(
      `/api/markups/revshop-org-markup`,
      markup
    );
  },
  getRevshopOrgMarkup: async (page: number, size: number) => {
    return api.get<Paged<RevshopOrgMarkupDTO>>(
      `/api/markups/revshop-org-markup/page`,
      {
        page,
        size,
      }
    );
  },
};
export default markupService;
